import { createContext } from 'react';

export const GiftCardAmountContext = createContext<((amount: number) => void) | null>(null);
